// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro page.
 */
enum EnumPage {
    FIRST = 'FIRST', 
    LAST = 'LAST'
};
export default EnumPage;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumPage.FIRST]: {caption: ''},
    [EnumPage.LAST]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
